import {
  ConfigureOptionsParams,
  FilterPassParams,
  AdvancedFilterName
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterHandlerBase } from './base/filter-handler-base';
import {
  IsSoleMgd,
  SyndicateMember,
  SyndicateRole
} from '../../../types/deal.types';

export class SoleManagedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.soleMgd;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    params.setFilterService.soleMgd = params.filterOptions.soleMgd;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const isSoleMgd = params.filters[this.name];
    const data = params.deal;
    let isSoleManagedFilterPassed = true;

    if (isSoleMgd) {
      if (!data.seniorManager) {
        isSoleManagedFilterPassed = false;
      } else {
        isSoleManagedFilterPassed = isSoleMgdPass(data, isSoleMgd.model.value);
      }
    }
    result.applyDealFilerResult(data.id, this.name, isSoleManagedFilterPassed);

    return isSoleManagedFilterPassed;
  }
}

export function isSoleMgdPass(data, soleMgd) {
  if (data.soleMgd !== null) {
    return !!IsSoleMgd[soleMgd] === data.soleMgd;
  } else {
    return isOldStyleSoleManaged(data.syndicate, !!IsSoleMgd[soleMgd]);
  }
}

function isOldStyleSoleManaged(
  syndicate: SyndicateMember[],
  isInclude: boolean
) {
  let hasSeniorManager = false;
  let hasNoOtherRoles = true;
  syndicate.forEach((value: SyndicateMember): void => {
    hasSeniorManager = hasSeniorManager
      ? hasSeniorManager
      : value.role === SyndicateRole.seniorManager;
    hasNoOtherRoles = hasNoOtherRoles
      ? value.role === SyndicateRole.seniorManager
      : hasNoOtherRoles;
  });
  return isInclude
    ? hasSeniorManager && hasNoOtherRoles
    : !(hasSeniorManager && hasNoOtherRoles);
}
